/**
 * The EVM Dust Cleaner's own host: <EVM_SUBDOMAIN>.<apex>. The page asks for
 * seed phrases, so it lives on its own subdomain and nowhere else (a wallet
 * blocklist flag lands on this host, not the apex). Renaming it means this
 * line, the route in wrangler.jsonc and the dev-server rewrite in
 * webpack.config.js. Chosen by the owner on 2026-10-30.
 */
export const EVM_SUBDOMAIN = "migration";

export const isEvmHostname = (hostname) => String(hostname || "").startsWith(`${EVM_SUBDOMAIN}.`);
